export enum MbcAssessmentNames {
  GAD_7 = 'GAD-7',
  PHQ_9 = 'PHQ-9',
}

export type IntakeType = 'gad7' | 'phq9'

export enum MbcScoreLabels {
  SUBCLINICAL = 'Subclinical',
  MILD = 'Mild',
  MODERATE = 'Moderate',
  MODERATELY_SEVERE = 'Moderately Severe',
  SEVERE = 'Severe',
  INVALID_SCORE = 'Invalid score',
}

export type MbcLabel = {
  name: MbcScoreLabels | ''
  color: string
}

export type AssessmentScore = {
  date: string
  score: number
  visitType?: string
}

export type MbcDetail = {
  field: {
    title: string
  }
  value: string
}

export type MbcForm = {
  answers: MbcDetail[]
}

export type MbcAssessment = {
  createdAt: Date
  form: MbcForm
  responseId: string
  score: number
  targetIds?: {
    pendingVisitId: string
  }
  emergencyWarning?: boolean
  updatedAt: Date
}

export type Intakes = {
  gad7: MbcAssessment
  phq9: MbcAssessment
}
